import React from 'react';
import classNames from 'classnames';
import propTypes from 'prop-types';
import { getMessage } from 'util/locale';

// components
import CheckboxRadio from 'common/CheckboxRadio';
import Explainer from 'planting-plan-form/Explainer';
import HtmlText from 'html-text/HtmlText';


const baseString = 'vra-planting-fertilizer-application';
const PlantingFertilizerApplication = ({
  helpTextKey,
  isFormFieldset,
  labelTextKey='label-text__planting-fertilizer-application',
  hasPlantingFertilizerApplication,
  onChange
}) => {
  const classString = classNames({
    [`${baseString}`]: true
  });

  const caption = (
    <HtmlText messageKey={helpTextKey} />
  );

  return (
    <section className={classString}>
      <div className='vra-planting-plan-form__inputs-wrapper'>
        <CheckboxRadio
          dataTestId={baseString}
          isChecked={hasPlantingFertilizerApplication}
          labelText={getMessage(labelTextKey)}
          name='planting-fertilizer-application'
          onChange={onChange}
        />
      </div>
      {
        isFormFieldset ? (
          <Explainer>
            {caption}
          </Explainer>
        ) : (
          <small>
            {caption}
          </small>
        )
      }
    </section>
  );
};
PlantingFertilizerApplication.propTypes = {
  hasPlantingFertilizerApplication: propTypes.bool.isRequired,
  helpTextKey: propTypes.string.isRequired,
  isFormFieldset: propTypes.bool.isRequired, // TODO - no current code is passing true to this prop. Can above conditional rendering be removed?
  labelTextKey: propTypes.string,
  onChange: propTypes.func.isRequired
};
export default PlantingFertilizerApplication;
